import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ptBR from './i18n/pt-BR.json';
import en from './i18n/en.json';
import es from './i18n/es.json';

const resources = {
  pt: { translation: ptBR },
  en: { translation: en },
  es: { translation: es }
};

const LANGUAGE_KEY = 'dominoris.language';

function detectLanguage(): 'pt' | 'en' | 'es' {
  if (typeof window !== 'undefined') {
    const stored = window.localStorage.getItem(LANGUAGE_KEY);
    if (stored === 'pt' || stored === 'en' || stored === 'es') return stored;
  }
  const lang = navigator.language.toLowerCase();
  if (lang.startsWith('pt')) return 'pt';
  if (lang.startsWith('es')) return 'es';
  return 'en';
}

i18n.use(initReactI18next).init({
  resources,
  lng: detectLanguage(),
  fallbackLng: 'pt',
  interpolation: {
    escapeValue: false
  }
});

export function persistLanguage(lang: 'pt' | 'en' | 'es'): void {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(LANGUAGE_KEY, lang);
  updateHtmlLang(lang);
}

function updateHtmlLang(lang: string): void {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = lang;
  }
}

// Set initial HTML lang on load
updateHtmlLang(detectLanguage());

export default i18n;
